import getSymbolFromCurrency from 'currency-symbol-map';
import numeral from 'numeral';

export function noNaN(n) {
  return Number.parseFloat(n) ? n : 0;
}

if (numeral.locales.custom === undefined) {
  numeral.register('locale', 'custom', {
    ...numeral.localeData(),
    abbreviations: {
      thousand: 'K',
      million: 'M',
      billion: 'B',
      trillion: 'T',
    },
  });
}
numeral.locale('custom');

export const ShowSignEnum = Object.freeze({
  NEGATIVE_ONLY: 'negative-only',
  POSITIVE_ONLY: 'positive-only',
  NEVER: 'never',
  ALWAYS: 'always',
});

export function formatNumber(val, currencySymbol = 'USD', fmtString = '0,0', showSign = ShowSignEnum.NEGATIVE_ONLY) {
  return internalFormatNumber(val, getSymbolFromCurrency(currencySymbol || 'N/A') || '', fmtString, showSign);
}

export function decimalCount(num) {
  if (Number.isInteger(num)) {
    return 0;
  } else {
    return num?.toString()?.split('.')[1]?.length || 0;
  }
}

export function round(value, decimals = 2) {
  const roundedValue = Math.round(Number(`${value || 0}e${decimals}`));
  return Number(`${roundedValue}e-${decimals}`);
}

export function getRoundedInvestmentVal(num) {
  let count = decimalCount(num);
  if (count < 2) {
    count = 2;
  } else if (count > 4) {
    count = 4;
  }
  return num.toFixed(count);
}

export function internalFormatNumber(
  val,
  currencyString,
  fmtString,
  showSign = ShowSignEnum.NEGATIVE_ONLY,
  showFractions,
  fractionDigits = 2,
) {
  const useFractionalVal = showFractions && Math.abs(val) < 0.01 && val !== 0;
  const value = useFractionalVal ? noNaN(val) : noNaN(round(val, fractionDigits));
  let sign = '';
  switch (showSign) {
    case ShowSignEnum.POSITIVE_ONLY:
      sign = Number(value) > 0 ? '+' : '';
      break;
    case ShowSignEnum.NEVER:
      sign = '';
      break;
    case ShowSignEnum.ALWAYS:
      sign = Number(value) > 0 ? '+' : '-';
      if (Number(value) === 0) sign = '';
      break;
    case ShowSignEnum.NEGATIVE_ONLY:
    default:
      sign = Number(value) < 0 ? '-' : '';
  }
  if (useFractionalVal) {
    return `${sign}${currencyString}${getRoundedInvestmentVal(Math.abs(value))}`;
  }

  return `${sign}${currencyString}${numeral(Math.abs(value)).format(fmtString)}`;
}
